import { getV1CompaniesCompanyIdProjectsEmails } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { ProjectEmailDraft } from '~hooks/useProjects/models';
import useEmailDraftsQuery from '~queries/useEmailDraftsQuery';

export default function useProjectEmailDraftsQuery(
  companyId: string,
  projectIds: string[],
) {
  return useEmailDraftsQuery({
    enabled: Boolean(companyId) && projectIds.length > 0,
    errorMessage: t('error_messages.projects.failed_to_fetch_email_drafts'),
    fetchDrafts: async (signal) => {
      const response = await getV1CompaniesCompanyIdProjectsEmails({
        path: { 'company-id': companyId },
        query: { project_ids: projectIds },
        signal,
      });

      return { drafts: response.data.data.emails.map(ProjectEmailDraft.parse) };
    },
    queryKey: ['projectEmailDrafts', companyId, projectIds],
  });
}
